export default __webpack_public_path__ + "static/bundle-e899f22dcfa8ec4b431b8224cadcfa1f.png";